<button 
  class="base {{color}} {{variant}} {{size}}" 
  type="{{type}}"
  (click)="onClickButton($event)"
>
  <ng-content></ng-content>
</button>

